<template>
  <div class="dashboard__card dashboard__card--no-min" v-cloak>
    <CardLoading v-if="loading"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loading }">
      <div class="dashboard__card-header h-no-margin-top h-no-margin-bottom">
        <div class="dashboard__card-title">Contacts</div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--library"> <span class="glyphicon glyphicon-user" aria-hidden="true"></span></div>
      </div>
      <Contacts></Contacts>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CardLoading from './CardLoading.vue';
  import Contacts from '../practice-info/Contacts.vue';

  export default {
    name: 'ContactsCard',
    components: {
      CardLoading,
      Contacts,
    },
    computed: {
      ...mapGetters('contacts', { 'contactsLoading': 'loaders' }),
      loading() {
        return this.contactsLoading.contacts;
      },
    },
  };
</script>
